import { LeadInput, LeadSchema, LeadSubmissionResult } from '../types/lead.js';

/**
 * 見込み客（Lead）送信 API クライアント
 */
export async function submitLead(input: LeadInput): Promise<LeadSubmissionResult> {
  // クライアント側バリデーション
  const parseResult = LeadSchema.safeParse(input);
  if (!parseResult.success) {
    const firstError = parseResult.error.errors[0]?.message || '入力内容に誤りがあります';
    return {
      success: false,
      message: firstError,
    };
  }

  try {
    const response = await fetch('/api/leads', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(parseResult.data),
    });

    if (!response.ok) {
      let errorMessage = `エラーが発生しました (${response.status})`;
      try {
        const errorData = await response.json();
        if (errorData.message) errorMessage = errorData.message;
      } catch {
        // レスポンスがJSONでない場合はステータスメッセージ
      }
      return {
        success: false,
        message: errorMessage,
      };
    }

    const data = await response.json();
    return {
      success: true,
      leadId: data.lead_id || data.id,
      message: 'お問い合わせを受け付けました。担当者より24時間以内にご連絡いたします。',
    };
  } catch (err: unknown) {
    console.error('[LeadApi] Failed to submit lead:', err);
    return {
      success: false,
      message: 'ネットワーク接続エラーが発生しました。時間をおいて再送信してください。',
    };
  }
}
